<m-session *ngIf="showContent" class="h-full w-full"></m-session>
<div *ngIf="showContent$ | async"></div>
